<script>
    export default {
        props: {
            picture: {
                type: String
            },
            userName: {
                type: String
            }
        }
    }
</script>

<template>
    <div v-if="picture">
        <img class="avatar-image" :alt="userName" :src="`/storage/mediapool/profile_images/${picture}`" />
    </div>
    <div v-else>
        <img class="avatar-image" :alt="'No picture'" :src="'/img/avatar.png'" />
    </div>
</template>

<style scoped>
    .avatar-image {
        width: 144px;
        height: 144px;
        border-radius: 8px;
    }
</style>
